import client from '.'
import { getAuthHeaders } from 'utils/requests'
import { cacheClear } from 'utils/memoryCache'

const PREFIX = 'schedule:'

const createSchedule = async scheduleCreate => {
  
  const headers = { headers: getAuthHeaders() }
  const save =  await client.post('/create',scheduleCreate, headers)

  cacheClear(PREFIX)
 
  return save 

}

export default createSchedule
